'use strict';

angular.module('ClinicApp').directive('appointmentOfferedAppointmentTypeSelect', function() {
  return {
    templateUrl: '/views/directives/_appointment-offered-appointment-type-select.html',
    require: 'ngModel',
    scope: {
      appointment: '=',
      provider: '=',
      formSubmitted: '=',
      disabled: '=',
    },
    link: function($scope, _el, _attr, ngModelCtrl) {
      $scope.ngModelCtrl = ngModelCtrl;

      $scope.$watch('offeredAppointmentType', setModel);
      $scope.$watch('provider', refreshControl);
      $scope.$watch('appointment', refreshControl);

      function setModel() {
        ngModelCtrl.$setViewValue($scope.offeredAppointmentType);
      }

      function refreshControl() {
        if (!$scope.provider) {
          return;
        }

        // Create a map of specialty name -> appointment type -> [offered appointment types]
        var offeredAppointmentTypesOptions = _.chain($scope.provider.offeredAppointmentTypes).groupBy('appointmentType.specialty.name')
          .mapValues(function(offeredAppointmentTypes) {
            return _.groupBy(offeredAppointmentTypes, 'appointmentType.name');
          })
          .value();

        // Flatten the map into an array of options.
        $scope.offeredAppointmentTypesOptions = _.transform(
          offeredAppointmentTypesOptions,
          function(result, offeredAppointmentTypesByAppointmentTypeName, specialtyName) {
            _.each(_.keys(offeredAppointmentTypesByAppointmentTypeName).sort(), function(appointmentTypeName) {
              _.each(_.sortByOrder(offeredAppointmentTypesByAppointmentTypeName[appointmentTypeName], ['duration'], ['asc']), function(offeredAppointmentType) {
                result.push({
                  specialtyName: specialtyName,
                  appointmentTypeName: appointmentTypeName + ' (' + offeredAppointmentType.duration + ' minutes)',
                  offeredAppointmentType: offeredAppointmentType,
                });
              });
            });
          },
          [],
        );

        $scope.offeredAppointmentType = _.find(
          $scope.provider.offeredAppointmentTypes,
          function(offeredAppointmentType) {
            return offeredAppointmentType.id == $scope.appointment.offeredAppointmentType.id;
          },
        );
        setModel();
      }
    },
  };
});
